import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['error']

  onError(event) {
    this.errorTarget.classList.add('is-visible')
    this.errorTarget.innerHTML = event.detail[0]
    event.preventDefault()
  }
}
